import React, { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Tooltip } from "../../revvComponents";

class UndoButton extends Component {
  _handleUndo = () => {
    // Below Code is being used for updating the
    // current active text editor data before doing Undo
    // const { section } = this.props;
    // if (section && section.type === "HTML") {
    //   const secElement = document.getElementById(
    //     `edit_editor_id_${section.id}`,
    //   );
    //   if (secElement) {
    //     secElement.focus();
    //   }
    // }

    this.props.handleUndo(this.props.mode);
  };

  onWindowClick = () => {
    this.props.onOverrideContent(undefined);
  };

  render() {
    return (
      <div
        className="draft-edit-items"
        id="toolbar-undo-button"
        key="toolbar-undo-button">
        <div className="draftJsToolbar__buttonWrapper__1Dmqh">
          <Tooltip
            placement="top"
            overlay="Undo"
            align={{
              offset: [3, 0],
            }}>
            <button
              type="button"
              className="undo-button toolbar-btn"
              data-test="toolbar-undo-button"
              onMouseDown={this._handleUndo}>
              <i>
                <FontAwesomeIcon icon={["far", "undo"]} />
              </i>
            </button>
          </Tooltip>
        </div>
      </div>
    );
  }
}

export default UndoButton;
